import { style } from '@/styles/globals';
import { styled } from '@mui/system';

export const SEOPageWrapper = styled('div')`
  height: 100vh;
  /* overflow-x:hidden; */
  background:${style.color.white2};
  .category-container {
    padding: 16px 0px;
  }

  .category-item {
    margin-right: 8px;
  }
`;
